import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api';

export default function ResetPassword() {
  const [searchParams]          = useSearchParams();
  const navigate                = useNavigate();
  const token                   = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [done, setDone]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 6)  { setError('Password must be at least 6 characters.'); return; }
    setLoading(true); setError('');
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div className="container" style={{ maxWidth: 420, paddingTop: 60, textAlign: 'center' }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
      <h2>Invalid Link</h2>
      <p style={{ color: '#6b7280', marginBottom: 24 }}>This reset link is invalid or has expired.</p>
      <Link to="/forgot-password" className="btn btn-primary" style={{ display: 'inline-block' }}>Request New Link</Link>
    </div>
  );

  return (
    <div className="container" style={{ maxWidth: 420, paddingTop: 60 }}>
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <h1 style={{ marginBottom: 8 }}>Set New Password</h1>
        <p style={{ color: '#6b7280' }}>Choose a strong password for your account.</p>
      </div>

      <div style={{ background: 'white', borderRadius: 12, padding: 32, border: '1px solid #e5e7eb' }}>
        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ marginBottom: 8 }}>Password Updated!</h2>
            <p style={{ color: '#6b7280', marginBottom: 24 }}>Redirecting you to login…</p>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block' }}>Go to Login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {[
              { label: 'New Password', value: password, onChange: setPassword, placeholder: 'Min. 6 characters' },
              { label: 'Confirm Password', value: confirm, onChange: setConfirm, placeholder: 'Repeat new password' },
            ].map(({ label, value, onChange, placeholder }) => (
              <div key={label} style={{ marginBottom: 18 }}>
                <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 6 }}>{label}</label>
                <input
                  type="password" required
                  value={value} onChange={e => onChange(e.target.value)}
                  placeholder={placeholder}
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
            ))}
            {error && (
              <div style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13 }}>
                {error}
              </div>
            )}
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Updating…' : 'Update Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
